import { __decorate, __metadata, __param } from "tslib";
import { i18nSymbol } from '@/i18n';
import { inject, provide } from '@/inversify.config';
import { getCommentEditableSpaceListApi, getCommentSpaceListApi, postCommentListApi, postVisibleScopeApi } from '@cores/apis/workspace_api/comments';
import _ from 'lodash';
import { ANALYTICS_URI, EUREKA_URI, SYNAPSE_URI } from '@cores/constants/envConfig';
export const MyCommentsServiceSymbol = Symbol.for('MyCommentsService');
const rangeKeys = ['ALL', 'ORG', 'SPACE', 'PRIVATE'];
const typeKeys = ['ALL', 'COMMENT', 'REPLY'];
const locationKeys = ['ALL'];
const sortKeys = ['UPDATE_TIME_DESC', 'UPDATE_TIME_ASC'];
export var RangeMap;
(function (RangeMap) {
    RangeMap["ALL"] = "ALL";
    RangeMap["SPACE"] = "SPACE";
    RangeMap["ORG"] = "ORG";
    RangeMap["PRIVATE"] = "PRIVATE";
})(RangeMap || (RangeMap = {}));
const productLinkMap = {
    Analytics: `${ANALYTICS_URI}/patent-view?source_type=workspace&patentId=\${patentId}`,
    Eureka: `${EUREKA_URI}/view/#?source_type=workspace&patentId=\${patentId}`,
    Synapse: `${SYNAPSE_URI}/patent/\${patentId}?source_type=workspace`,
};
let MyCommentsService = class MyCommentsService {
    constructor(i18n) {
        this.i18n = i18n;
    }
    getFilterConfig() {
        return {
            rangeOptions: _.map(rangeKeys, (item) => ({ value: item, label: this.i18n.t(`workspace.myComments.range.${item}`) })),
            typeOptions: _.map(typeKeys, (item) => ({ value: item, label: this.i18n.t(`workspace.myComments.type.${item}`) })),
            locationOptions: _.map(locationKeys, (item) => ({ value: item, label: this.i18n.t(`workspace.myComments.location.${item}`) })),
            sortOptions: _.map(sortKeys, (item) => ({ value: item, label: this.i18n.t(`workspace.myComments.sort.${item}`) })),
        };
    }
    getCommentList(params) {
        return postCommentListApi(params);
    }
    postVisibleScopeApi(params) {
        return postVisibleScopeApi(params);
    }
    getCommentWorkspaceList(space_name) {
        return getCommentSpaceListApi(space_name);
    }
    getCommentEditableSpaceListApi(space_name) {
        return getCommentEditableSpaceListApi(space_name);
    }
    getCommentWorkspaceListOptions(data, space_name) {
        const { shared, org, self } = data;
        const spaceName = _.toLower(space_name);
        const spaceList = [{
                label: this.i18n.t('workspace.sort.self'),
                type: 'self',
                children: _.flatMap(self, (item) => {
                    if (_.includes(_.toLower(item.space_name), spaceName)) {
                        return [{ value: item.space_id, label: item.space_name, type: 'self', ...item }];
                    }
                    return [];
                }),
            }, {
                label: this.i18n.t('workspace.sort.shared'),
                type: 'shared',
                children: _.flatMap(shared, (item) => {
                    if (_.includes(_.toLower(item.space_name), spaceName)) {
                        return [{ value: item.space_id, label: item.space_name, type: 'shared', ...item }];
                    }
                    return [];
                }),
            }, {
                label: this.i18n.t('workspace.sort.public'),
                type: 'org',
                children: _.flatMap(org, (item) => {
                    if (_.includes(_.toLower(item.space_name), spaceName)) {
                        return [{ value: item.space_id, label: item.space_name, type: 'org', ...item }];
                    }
                    return [];
                }),
            }];
        return _.filter(spaceList, (item) => item.children.length > 0);
    }
    highlightText(text, word, className = 'bg-green-75') {
        text = _.escape(text);
        if (!word)
            return text;
        word = _.escapeRegExp(word);
        const regex = new RegExp('(' + word + ')', 'gi');
        return text.replace(regex, `<span class="comment-hight-target ${className}">$1</span>`);
    }
    getLinkByProduct(product, patentId) {
        return _.template(productLinkMap[product])({ patentId });
    }
};
MyCommentsService = __decorate([
    provide(MyCommentsServiceSymbol),
    __param(0, inject(i18nSymbol)),
    __metadata("design:paramtypes", [Object])
], MyCommentsService);
export { MyCommentsService };
